import React, { useEffect } from 'react';
import { useLocation } from '@reach/router';
import { Link } from '../basic/Links';
import { BoundaryProps } from '../boundaries/Boundary';
import { pushErrorEventToDataLayer } from '../../analytics/pushErrorEventToDataLayer';

export const TEST_ID = {
  MAIN: 'location-not-found'
};

export interface NotFoundProps extends BoundaryProps {
  basePath: string;
  label: string;
}

function trackRouteNotFound(pageUrl: string) {
  pushErrorEventToDataLayer({
    error_type: 'unknown_error',
    error_category: 'frontend',
    error_code: 'ROUTE_NOT_FOUND',
    error_description: `Route not found: ${pageUrl}.`,
    error_location: 'NotFound.render',
    page_url: pageUrl
  });
}

export const NotFound: React.FC<NotFoundProps> = props => {
  const { basePath, label } = props;
  const location = useLocation();
  const pageUrl = `${location.pathname}${location.search || ''}`;

  useEffect(() => {
    trackRouteNotFound(pageUrl);
  }, [basePath, label, pageUrl]);

  return (
    <div style={{ textAlign: 'center' }} data-testid={TEST_ID.MAIN}>
      We couldn't find that location. We aren't sure how to continue, but you
      can <Link href={basePath}>go to {label}</Link>
    </div>
  );
};

NotFound.defaultProps = {
  default: true
};
